import { Decimal } from "./decimal";

// these props are used as mongoose getter/setter props
export const decimalStringProps = {
  type: String,
  get: (s: string): Decimal | undefined =>
    s != null && s !== "" ? Decimal.from(s) : undefined,
  set: (d: Decimal | undefined): string | null => (d ? d.toString() : null),
};
